import { useLocationGroupStore } from '@frontend/scope';
import { createShallowStore, createStoreWithPersist } from '@frontend/store';

type Step = 'select-persons' | 'compose-message';

type State = {
  selectedLocationId?: string;
  selectedPersonIds: string[];
  locationWiseTotalCounts: Record<string, number>;
  currentStep: Step;
};

type Actions = {
  makeSetSelectedPersonIds: (locationId: string) => (personIds: string[]) => void;
  setLocationWiseTotalCount: (locationId: string, count: number) => void;
  setLocationWiseTotalCounts: (locationWiseTotalCounts: Record<string, number>) => void;
  setCurrentStep: (step: Step) => void;
  resetUserSelections: () => void;
};

type Store = State & Actions;

const initialState: State = {
  selectedPersonIds: [],
  locationWiseTotalCounts: {},
  currentStep: 'select-persons',
};

const useStore = createStoreWithPersist<Store>(
  (set) => ({
    ...initialState,
    makeSetSelectedPersonIds: (locationId) => (personIds) =>
      set({ selectedPersonIds: personIds, selectedLocationId: locationId }),
    setLocationWiseTotalCounts: (locationWiseTotalCounts) => set({ locationWiseTotalCounts }),
    setLocationWiseTotalCount: (locationId, count) =>
      set((state) => ({ locationWiseTotalCounts: { ...state.locationWiseTotalCounts, [locationId]: count } })),
    setCurrentStep: (step) => set({ currentStep: step }),
    resetUserSelections: () =>
      set({
        selectedPersonIds: [],
        currentStep: 'select-persons',
      }),
  }),
  {
    name: 'schedule-waitlist-store',
  },
  {
    name: 'ScheduleWaitlistStore',
    trace: true,
  }
);

const resetStore = () => useStore.setState(initialState);

useLocationGroupStore.subscribe((state) => state.locationData, resetStore);
useLocationGroupStore.subscribe((state) => state.selectedLocationIds, resetStore);

export const useWaitlistShallowStore = createShallowStore(useStore);
